import { posthogService } from '@/lib/posthog';
import { Category } from '@/types';

export const getTypeId = (slug: string) => {
  if (slug === 'all' || !slug) return undefined;
  if (slug === 'image') return 1;
  if (slug === 'text') return 2;
  // if (slug === 'video') return ...;
  return undefined;
};

export const generateCategorySlugPath = (item: Category): string => {
  const slug = item.slug;
  if (item.parent) {
    return `${generateCategorySlugPath(item.parent)}\\${slug}`;
  }
  return slug;
};

export const trackEvent = (eventName: string, payload: any) => {
  if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_POSTHOG_ENABLED_FOR_DEBUG) {
    try {
      posthogService.capture(eventName, payload);
      if (window.dataLayer) {
        window.dataLayer.push({
          event: eventName,
          ...payload,
        });
      } else {
        console.error('DataLayer not found');
      }
    } catch (error) {
      console.error('Error tracking event', error);
    }
  }
};

export const trackdeskEvent = (email: string) => {
  if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_POSTHOG_ENABLED_FOR_DEBUG) {
    if (typeof window !== 'undefined') {
      const trackdesk = window.trackdesk;
      try {
        trackdesk(process.env.NEXT_PUBLIC_AFFILIATE_ID, 'externalCid', {
          externalCid: email,
          revenueOriginId: process.env.NEXT_PUBLIC_REVENUE_ORIGIN_ID,
        });
      } catch (error) {
        console.error('Error tracking event', error);
      }
    }
  }
};

export const getPostHogDistinctId = () => {
  return posthogService.getDistinctId();
};
